import './localizationPatch'; // Патч для исправления ошибок локализации (React error #31)
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/mobile.css'; // Подключаем стили для мобильной оптимизации
import './styles/mobile-menu.css'; // Подключаем стили для мобильного меню
import App from './App';
import reportWebVitals from './reportWebVitals';
import { register as registerServiceWorker } from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Регистрация Service Worker для поддержки PWA
registerServiceWorker();

// Аналитика веб-производительности
reportWebVitals(console.log);
